<div class="container" style="position: fixed;
  top: 0;
  left: 0; 
  height: 100%;
  background: #f5f5f5;">
Waiting for authorization...
<span class="fa fa-spinner spinner"></span>
</div>